<template>
  <div class="wrap wrap-gl">
    <onion-gl id="oniongl"></onion-gl>
    <modal v-show="show_modal" @close="toggleModal" />
    <chat v-if="chat" v-bind:is_artist="is_artist" v-bind:name="storeState.name" v-bind:visible="show_chat" v-bind:messages="messages" @send="send" />

    <div id="btn" v-on:click="toggleChat" v-if="!show_modal">

      <p style="color: #fff; font-size: 20px; font-weight: 700;">CHAT</p>
      <!-- <p style="color: #fff; font-size: 20px; font-weight: 700;">{{ this.sound ? 'MUTE' : 'UNMUTE' }}</p> -->
    </div>

    <div class="popup" v-if="popup.visible">
      <p style="color: #fff; font-size: 18px;"><a v-bind:href="popup.link" target="_blank" style="color: #fff; text-decoration: none;">{{popup.message}}}</a></p>
    </div>

    <transition name="fade">
      <div v-if="keys" style="top: 0; position: fixed; z-index: 500000; display: flex; width: 100vw; height: 100vh; justify-content: center; align-items: center;">
        <p style="color: #fff; font-size: 24px; max-width: 500px; padding: 2rem">Use the <b>A S D W keys</b> to move, and click and drag the mouse to rotate the camera view!</p>
      </div>
    </transition>

    <!-- <div class="bkg"></div> -->
    <!-- <div style="position: absolute; right: 14px; top: 14px">
      <span class="btn donation-counter">$12,430 raised</span>
      <button v-on:click="toggleDonate()" class="btn btn-hollow">DONATE</button>
    </div> -->
  </div>
</template>

<script>
// import '@umg-innovations/onion-gl';
import store from "../../store";
// import modal from "./components/donate-modal";
import modal from "./components/stream-modal";
import chat from "./components/chat";

import AudioService from "./services/audio-service";
import data from './services/data';
const {isrcs,markers,duration} = data;

import io from "socket.io-client";

import { StoreHandler } from './handlers/StoreHandler';
import { VideoHandler } from './handlers/VideoHandler';
import { FireHandler } from './handlers/FireHandler';

import song from './songs/chan.json'

export default {
  name: "WebGL",
  data: function() {
    return {
      storeState: store.state,
      audioService: null,
      show_modal: false,
      messages: [],
      socket: null,
      sound: true,
      is_artist: false,

      chat: true,

      is_mobile: (a => {return !!(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) })(navigator.userAgent||navigator.vendor||window.opera),

      show_chat: false,

      keys: true,

      is_safari: /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)),


      popup: {
        visible: false,

        title: '',
        message: 'Click to snap Trippie',
        prompt: '',
        link: 'https://snapchat.com/add/trippieredd'
      }
    };
  },
  methods: {
    toggleModal() {
      this.show_modal = !this.show_modal;
    },
    toggleChat() {
      this.show_chat = !this.show_chat;
    },

    toggleSound() {
      if(this.sound) {
        this.audioService.soundOff()
        this.sound = false;
      } else {
        this.audioService.soundOn();
        this.sound = true;
      }
    },

    send(msg) {
      if (!msg) return;
      if (msg === " ") return;

      this.socket.emit("chat", {
        name: this.storeState.name,
        msg
      });


      if(msg.indexOf('storyboard!!2%784') > -1)
        return this.is_artist = true;

      this.messages.push({
        name: this.storeState.name,
        msg,
        b: this.is_artist,
        nameColor: this.is_artist ? '#ffcc66' : "#b3d9ff",
        chatColor: "#fff"
      });
    },

    checkVideo() {
      let track = this.getTrack(this.storeState.START_TIME);

      oniongl.update({
        video_url: track.video_url,
        progress: track.progress / 1000,
        timestamp: Date.now()
      })
    },

    /**
     * get the current track, and it's current progress
     */
    getTrack(startTime) {
      let lapsedTime = (Date.now() - startTime)
        , position = lapsedTime - Math.floor(lapsedTime / duration) * duration
        , track = {uri: '', marker: null, video_url: ''};


      // iterate through the markers
      Object.keys(markers).forEach((uri, index) => {
        // if its marker is less than our current position, quit it
        if(markers[uri] > position) return;

        // if the there is no base track
        if(!track.marker) return track = {index, marker: markers[uri], video_url: isrcs[uri].video_url};

        // if it's the closest to the clock
        if(markers[uri] > track.marker) return track = {index, marker: markers[uri], video_url: isrcs[uri].video_url};
      })

      return {...track, progress: position - track.marker};
    },

    // mobile resync
    async resync() {
      let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
      let res = await fetch(`${this.storeState.API_URL}/resync?accessToken=${this.storeState.access_token}&ns=${subdomain}`);
      res = await res.json();

      if(!res.success)
        return this.show_modal = true;

      this.show_modal = false;


      oniongl.update({
        video_url: res.video_url,
        progress: res.progress / 1000,
        timestamp: res.timestamp
      })
    }
  },
  mounted() {
    let oniongl = document.getElementById('oniongl');

    let self = this;
    // timeout the a s d button notice
    if(!this.is_mobile)
      setTimeout(() => self.keys = false, 2200)

    /* dont scroll down */
    // window.onkeydown = e => !(e.keyCode == 32);

    /**
     * POPUP LISTENERS
     */
    window.TRIGGER_OPEN_POPUP = data => {

      this.popup = {
        visible: true,

        ...data
      }
    }

    window.TRIGGER_CLOSE_POPUP = () => this.popup = {...this.popup, visible: false};

    let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    this.socket = io(this.storeState.WSS_URL + '?ns=' + subdomain + '&access_token=' + this.storeState.access_token);

    this.socket.on("chat", data => {
      this.messages.push({
        nameColor: "#b3d9ff",
        chatColor: "#fff",
        ...data
      });
    });

    let vue_this = this;
    (function trytoload() {
      if(!oniongl.update)
        return setTimeout(trytoload, 500);

      load();
    })()


    async function load() {
      oniongl.update({
        // songDataSrc: 'https://raw.githubusercontent.com/UMG-Innovations/onion-frontend/master/data/song/ransom.json?token=AB6A5CFBA3HL7QJLNBOEVES7HLHHO',
        // songDataSrc: 'https://raw.githubusercontent.com/UMG-Innovations/onion-frontend/master/data/song/always.json?token=AB6A5CCEF3JH6ZE7TL67Q4S7I7ZH2',
        timelineDataSrc: 'https://umg-innovations.github.io/onion-frontend/data/timeline/forest-map.json',
        // sceneDataSrc: 'https://rest.onelve.com/devmap.glb',
        sceneDataSrc: '/keshi2.glb',
        // sceneDataSrc: '/keshi.glb',
        // sceneDataSrc: 'https://onion.nyc3.cdn.digitaloceanspaces.com/keshi.glb',

        socketServer: 'wss://game-server.storyboard.gg',
        // socketServer: 'ws://localhost:3000',
        
        // sceneDataSrc: 'https://umg-innovations.github.io/onion-frontend/data/scene/pokemon-demo.glb',
        sceneHandlers: [StoreHandler, VideoHandler, FireHandler],
        username: store.state.name,

        progress: 0,
        timestamp: Date.now(),
      });

      // oniongl.update({
      //   video_url: 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1280_10MG.mp4',
      //   progress: 0,
      //   timestamp: Date.now(),
      // });


      if(vue_this.is_mobile)
        vue_this.keys = false;

      // spotify mobile setup
      if(vue_this.is_mobile && vue_this.storeState.access_token) {
        window.onfocus = vue_this.resync;
        vue_this.keys = false;

        let res = await fetch(`${vue_this.storeState.API_URL}/mobile-playing?accessToken=${vue_this.storeState.access_token}`);
        res = await res.json();

        vue_this.checkVideo()
        setInterval(vue_this.checkVideo, 15000)

        // is this client playing?
        if(res.is_playing) {
          vue_this.resync();
          return;
        }

        vue_this.show_modal = true;
        vue_this.keys = false;
        return;
      } else if(vue_this.storeState.access_token && (!vue_this.storeState.spotify_premium)) {
        // if the user isnt a spotify premium user
        vue_this.keys = false;
        vue_this.show_modal = true;
      } else if(vue_this.is_safari && vue_this.storeState.access_token) {
        window.onfocus = vue_this.resync;
        vue_this.keys = false;

        let res = await fetch(`${vue_this.storeState.API_URL}/mobile-playing?accessToken=${vue_this.storeState.access_token}`);
        res = await res.json();

        // is this client playing?
        if(res.is_playing)
          return vue_this.resync();

        vue_this.show_modal = true;
        vue_this.keys = false;
      }

      vue_this.audioService = new AudioService(
        store.state.START_TIME, // start time 
        null, // tracks
        {
          id: vue_this.storeState.access_token ? 1 : 2,
          access_token: vue_this.storeState.access_token
        }, // dsp
        oniongl // gl
      );

      // start playing music
      vue_this.audioService.init();
    }


  },
  components: {
    modal,
    chat
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let god = urlParams.get('god');

    if(god !== null)
      this.chat = false; 

    // function update(time) {
    //   requestAnimationFrame(update);
    //   this.$refs.oniongl.currentTime = time;
    // }
    // requestAnimationFrame(update);

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrap-gl {
  width: 100%;
  height: 100%;
}

.popup {
  position: fixed;
  top: 4rem;
  width: 100vw;
  text-align: center;
  font-family: 'Rowdies', cursive;
}

onion-gl {
  width: 100%;
  height: 100%;
}

.donate-btn {
  padding: 4px 24px;
  font-size: 32px;
  background-color: #fff;
}

.bkg {
  /*background-image: url(https://i.imgur.com/rgNeWbM.png);*/
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: -1;
  background-position: cover;
  background-size: contain;
  /*opacity: .8;*/
}

.btn {
  display: block;
  /*width: 300px;*/
  padding: 6px 24px;
  text-align: center;
  font-size: 30px;
  cursor: pointer;
}

.donation-counter {
  color: #000;
  background-color: #ffbb99;
  border: 4px solid #ffbb99;
}

/* .btn-fill:hover {
    opacity: .9;
  }*/

.btn-hollow {
  color: #ffbb99;
  width: 100%;
  border: 4px solid #ffbb99;
  background: none;
}

.btn-hollow:hover {
  color: #000;
  background-color: #ffbb99;
}

::-webkit-scrollbar {
  width: 0px;
}

#btn {
  display: none;
  z-index: 50000; 
  position:fixed; 
  top: 0; 
  right:0; 
  cursor: pointer;
  margin: 16px;
  font-size: 24px;
  font-family: 'Rowdies', cursive;
  color: #fff;
}
@media screen and (max-width: 740px) {
  #btn {
    display: block!important;
  }
}
</style>
